module.exports = __webpack_public_path__ + "static/media/dr-barkas.adb4c7ae.jpg";